'use strict';
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {epicErrorHandler} from '../../../core-utilities/rx-utils/index';
import * as infoModalActions from '../../actions/infoModalActions';
import {getInfoModal} from '../../reducers';
import {InfoModalView} from './InfoModalView';
import {logger} from '../logger';


export const modalOptions = {
  isLegacy: true,
  modalProps: {
    modalClass: 'InfoModalModal',
    useScrollWrapper: false,
  },
};

export class InfoModalComponent extends Component {
  static propTypes = {
    // modal actions
    onSuccess: T.func/* .isRequired*/,
    onCancel: T.func/* .isRequired*/,
  };

  static $inject = [
    '$ngRedux',
  ];

  constructor(props) {
    super(props);

    /** @type {RequirementsInfoModalState} */
    this.state = {
      ...getInfoModal(InfoModalComponent.dependencies.$ngRedux.getState()),
    };

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose(e) {
    e.stopPropagation();
    if (isFunction(this.props.onCancel)) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <InfoModalView
        {...this.state}

        onClose={this.handleClose}
      />
    );
  }

  componentDidMount() {
    this.updateSubscription = InfoModalComponent.dependencies.$ngRedux.state$
      .map(getInfoModal)
      .distinctUntilChanged()
      .catch(epicErrorHandler(logger, 'infoModal$'))
      .delay(0)
      .subscribe(nextState => {
        if (!nextState.isShowingModal && isFunction(this.props.onSuccess)) {
          this.props.onSuccess();
        }
        this.setState(nextState);
      });
  }

  componentWillUnmount() {
    this.updateSubscription && this.updateSubscription.unsubscribe();
    InfoModalComponent.hide();
  }

  static hide() {
    InfoModalComponent.dependencies.$ngRedux.dispatch(infoModalActions.hideModal());
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/InfoModal/InfoModalComponent.js